import React from "react";
import { Typography } from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";

const returnMoment = (data) => {
    if (!data) return undefined;
    if (!isNaN(data)) {
        return moment(Date.now() + data * 1000 * 3600 * 24);
    } else if (isNaN(data)) {
        return moment(data);
    }
};

const workWithDate = (pickedName, pickedDate, updater) => {
    if (!pickedDate) return undefined;
    const formattedDate = pickedDate.format("yyyy-MM-DD");
    updater(pickedName, formattedDate);
};

export const dateRenderer = (
    value,
    name,
    restrictionMin,
    restrictionMax,
    fieldUpdateHandler,
    mutable,
    restrictionFieldName,
    isError,
) => {
    const momentValue =
        value === null &&
        (name == "date_start_booking" || name == "date_end_booking")
            ? null
            : returnMoment(value);

    if (!mutable) {
        return <Typography>{momentValue.format("DD/MM/yyyy")}</Typography>;
    }

    let momentRestrictionMax;
    let momentRestrictionMin;

    if (['cashback_stay_date_to', 'cashback_booking_date_to', 'date_end'].includes(restrictionFieldName)) {
        momentRestrictionMax = returnMoment(restrictionMax);
    } else if (['cashback_stay_date_from', 'cashback_booking_date_from', 'date_start'].includes(restrictionFieldName)) {
        momentRestrictionMin = returnMoment(restrictionMin);
    }

    // if (!isNaN(value) && !momentValue.isValid()) return undefined;
    if (momentRestrictionMax) {
        if (momentValue >= momentRestrictionMax) {
            const valueMomentCopy = { ...momentValue };
            let restrictionMomentFromValueCopy = moment(valueMomentCopy);
            const momentOfChangedDate = restrictionMomentFromValueCopy.add(
                1,
                "day",
            );
            if (momentOfChangedDate === momentValue) return undefined;
            workWithDate(
                restrictionFieldName,
                momentOfChangedDate,
                fieldUpdateHandler,
            );
        }
    }

    return (
        <MuiPickersUtilsProvider
            libInstance={moment}
            utils={MomentUtils}
            locale={"ru"}
        >
            <KeyboardDatePicker
                variant={"inline"}
                maxDate={moment().add(1, "y")}
                format="DD/MM/yyyy"
                margin="normal"
                minDate={momentRestrictionMin}
                value={momentValue}
                onChange={(date) =>
                    workWithDate(name, date, fieldUpdateHandler)
                }
                error={!!isError}
                helperText={isError}
                KeyboardButtonProps={{
                    "aria-label": "change date",
                }}
            />
        </MuiPickersUtilsProvider>
    );
};
